import * as yup from "yup";

const complementaryDataSchema = yup.object({
  mediaName: yup.string().max(200).required(),
  referralCode: yup.string(),
}).required();

export default complementaryDataSchema;
